import { api } from "api";
import type { NonIndexRouteObject } from "react-router-dom";

import ArtifactsRoute from "./ArtifactsRoute";
import ViewRoute from "./ViewRoute";

export const artifactsRoute: NonIndexRouteObject = {
  children: [
    {
      index: true,
      loader: ({ params }) => api.artifacts(params.executionId),
      element: <ArtifactsRoute />,
    },
    {
      path: "view/*",
      element: <ViewRoute />,
      loader: async ({ params }) => {
        const { executionId, "*": file } = params;
        const resp = await fetch(api.artifactURL(executionId!, file!));
        return resp.text();
      },
    },
  ],
};
